import { useFormContext, useWatch } from 'react-hook-form';

import { DatePickerTime } from 'shared_DEPRECATED/components/Form/DatePicker';
import { dateUtils } from 'shared_DEPRECATED/utils';

import { CoachingMode } from 'features/participants/config/types';
import {
  getDateStringWithUpdatedTime,
  getSessionEndTime,
} from 'features/sessions/utils';

import { Typography } from 'shared/components/Typography';

export const SessionsFormActualStartTimeSelector = () => {
  const { setValue } = useFormContext();
  const [sessionStartAtDate, coachingMode]: [string, CoachingMode] = useWatch({
    name: ['startedAt', 'coachingMode'],
  });

  const onTimeChange = (date: Date) => {
    const updatedStartedAtDate = getDateStringWithUpdatedTime(
      sessionStartAtDate,
      date
    );

    setValue('startedAt', updatedStartedAtDate, {
      shouldDirty: true,
    });

    const updatedSessionEndedAt = getSessionEndTime(
      updatedStartedAtDate,
      coachingMode
    );

    setValue('endedAt', updatedSessionEndedAt, {
      shouldDirty: true,
    });
  };

  return (
    <Typography as="div" type="meta" dataTestid="session-start-time">
      <DatePickerTime
        date={dateUtils.localDate(sessionStartAtDate || undefined).toDate()}
        onChange={onTimeChange}
      />
    </Typography>
  );
};
